function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_4_2)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M766 0H0V766H766V0Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M729.85 729.85H36.15V36.15H729.85V729.85ZM46.15 719.85H719.85V46.15H46.15V719.85Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M390.96 248.822C416.308 244.725 433.535 220.856 429.439 195.508C425.342 170.16 401.473 152.932 376.125 157.029C350.777 161.126 333.549 184.995 337.646 210.343C341.742 235.691 365.612 252.919 390.96 248.822Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M307.89 426.27V268.85C307.89 250.19 321.06 235.01 337.25 235.01H427C443.19 235.01 456.36 250.19 456.36 268.85V426.27H307.89Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M382.14 239.24C402.039 239.24 418.17 223.109 418.17 203.21C418.17 183.311 402.039 167.18 382.14 167.18C362.241 167.18 346.11 183.311 346.11 203.21C346.11 223.109 362.241 239.24 382.14 239.24Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M427 245.35H337.25C326.75 245.35 318.25 255.87 318.25 268.85V415.93H347.16V296.1H351.73V415.93H412.59V296.1H417.15V415.93H446.07V268.85C446.05 255.87 437.53 245.35 427 245.35Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M485.52 335.63C511.124 335.63 531.88 314.874 531.88 289.27C531.88 263.666 511.124 242.91 485.52 242.91C459.916 242.91 439.16 263.666 439.16 289.27C439.16 314.874 459.916 335.63 485.52 335.63Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M411.27 512.33V354.91C411.27 336.25 424.44 321.07 440.63 321.07H530.41C546.59 321.07 559.76 336.25 559.76 354.91V512.33H411.27Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M485.52 325.3C505.419 325.3 521.55 309.169 521.55 289.27C521.55 269.371 505.419 253.24 485.52 253.24C465.621 253.24 449.49 269.371 449.49 289.27C449.49 309.169 465.621 325.3 485.52 325.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M530.41 331.41H440.63C430.13 331.41 421.63 341.93 421.63 354.91V502H450.54V382.16H455.11V502H516V382.16H520.56V502H549.48V354.91C549.43 341.93 540.91 331.41 530.41 331.41Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M324.88 293.772C327.379 268.29 308.747 245.608 283.266 243.109C257.784 240.611 235.101 259.243 232.603 284.724C230.104 310.206 248.736 332.888 274.218 335.387C299.699 337.885 322.382 319.254 324.88 293.772Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M204.51 512.33V354.91C204.51 336.25 217.68 321.07 233.87 321.07H323.65C339.83 321.07 353 336.25 353 354.91V512.33H204.51Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M278.76 325.3C298.659 325.3 314.79 309.169 314.79 289.27C314.79 269.371 298.659 253.24 278.76 253.24C258.861 253.24 242.73 269.371 242.73 289.27C242.73 309.169 258.861 325.3 278.76 325.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M323.65 331.41H233.87C223.37 331.41 214.87 341.93 214.87 354.91V502H243.78V382.16H248.35V502H309.21V382.16H313.77V502H342.69V354.91C342.67 341.93 334.15 331.41 323.65 331.41Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M386.642 368.261C412.123 365.763 430.755 343.08 428.256 317.598C425.758 292.117 403.075 273.485 377.594 275.984C352.112 278.482 333.48 301.165 335.979 326.646C338.477 352.128 361.16 370.76 386.642 368.261Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M307.89 545.15V387.73C307.89 369.08 321.06 353.9 337.25 353.9H427C443.19 353.9 456.36 369.08 456.36 387.73V545.15H307.89Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M417.285 330.055C421.674 310.646 409.497 291.355 390.088 286.967C370.679 282.579 351.388 294.755 346.999 314.164C342.611 333.573 354.788 352.865 374.197 357.253C393.606 361.641 412.897 349.464 417.285 330.055Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M427 364.24H337.25C326.75 364.24 318.25 374.76 318.25 387.73V534.82H347.16V415H351.73V534.82H412.59V415H417.15V534.82H446.07V387.73C446.05 374.76 437.53 364.24 427 364.24Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M541.455 550.497L523.063 568.889L611.763 657.588L630.155 639.196L541.455 550.497Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M536.51 631.45V564H604.07V563.99L585.57 545.49H518.11H518V612.94L536.51 631.45Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M224.54 550.312L135.84 639.012L154.232 657.404L242.932 568.704L224.54 550.312Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M161.98 563.77H229.43V631.33H229.44L247.94 612.82V545.36V545.25H180.49L161.98 563.76V563.77Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M611.768 108.409L523.069 197.108L541.461 215.5L630.16 126.801L611.768 108.409Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M536.51 134.55V202H604.07V202.01L585.57 220.51H518.11H518V153.06L536.51 134.55Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M154.225 108.582L135.833 126.974L224.532 215.673L242.924 197.282L154.225 108.582Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M161.98 202.23H229.43V134.67H229.44L247.94 153.18V220.64V220.75H180.49L161.98 202.24V202.23Z",
  fill: "white"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_4_2"
}, /*#__PURE__*/React.createElement("rect", {
  width: 766,
  height: 766,
  fill: "white"
})));

var SvgEvacuate = function SvgEvacuate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 766,
    height: 766,
    viewBox: "0 0 766 766",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEvacuate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/evacuate.5cedecbc.svg";
export { ForwardRef as ReactComponent };